<script setup lang="ts">
import type TypeCode from '@/common/data/TypeCode'
import type IAccount from '@/common/models/IAccount'
import type {DeepReadonly} from 'vue'
import {VsgSelect, VsgTextInput} from '@jack-henry/jha-vue-components'
import LoanPurposeSelector from "@/common/components/productSelection/loanPurposeSelector.vue";
import LOAN_GROUPS from "@/common/components/productSelection/LoanGroupsEnum";
import {requireInject} from "@/common/utils/InjectUtil";
import {PRODUCT_SELECTION_INJECTION} from "@/common/services/Products/productSelectionInjection";
import LoanAmountInput from '@/common/components/productSelection/loanAmountInput.vue'

const props = defineProps<{
  intentions: Array<TypeCode>
  account: DeepReadonly<IAccount>
}>()

const injection = requireInject(PRODUCT_SELECTION_INJECTION)

const emits = defineEmits<{
  (e: 'updateAccount', account: DeepReadonly<IAccount>): void
}>()

const updateIntention = (event: CustomEvent<string>) => {
  emits('updateAccount', {...props.account, accountIntention: event.detail})
}

const updateDescription = (description: string) => {
  emits('updateAccount', {...props.account, description})
}

const isLoanProduct = (account: DeepReadonly<IAccount>) => {
  return Object.keys(LOAN_GROUPS).includes(account.accountGroup)
}
</script>

<template>
  <div class="two-wide-flex"
       :class="{'ac-loan' : injection.channel == 'open' }">
    <vsg-select
      v-if="!isLoanProduct(props.account) && injection.channel == 'branch'"
      :options="intentions"
      empty-option-label=" "
      outline
      @change="updateIntention"
      labelKey="typeDescription"
      valueKey="typeCode"
      :value="account.accountIntention"
      label="Account Intention" />

    <loan-purpose-selector v-if="isLoanProduct(props.account)"
                           :account/>

    <loan-amount-input v-if="isLoanProduct(props.account)"
                       :account/>

    <vsg-text-input
      outline
      v-if="injection.channel == 'branch'"
      @blur="updateDescription($event.target.value)"
      label="Account Description"
      :value="account.description" />
  </div>
</template>

<style scoped>
.two-wide-flex {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0 var(--jh-space-200);
  padding-bottom: var(--jh-space-400);
}

.two-wide-flex > * {
  flex: 1 0 calc(50% - var(--jh-space-200));
}

@media (max-width: 720px) {
  .two-wide-flex > * {
    flex: 1 1 100%;
  }
}

jha-form-currency-input {
  --jha-input-margin-bottom: 0;
}
</style>
